import React from 'react';
import { ChevronRight, LogOut } from 'lucide-react';

/* ── Mobile: Menu List ── */
const ProfileMobileMenu = ({ menuItems, handleMenuClick, handleLogout, handleDeleteProfile }) => {
  return (
    <div className="profile-mobile-menu">
      {menuItems.map((item) => (
        <div
          key={item.id}
          className="profile-mobile-item"
          onClick={() => handleMenuClick(item.route)}
        >
          <div className="profile-mobile-item-icon" style={{ backgroundColor: `${item.color}15` }}>
            <span style={{ color: item.color }}>
              {item.icon}
            </span>
          </div>
          <span className="profile-mobile-item-title">{item.title}</span>
          <ChevronRight className="profile-mobile-item-arrow" />
        </div>
      ))}

      {/* Mobile Logout */}
      <div
        className="profile-mobile-item profile-mobile-logout"
        onClick={handleLogout}
      >
        <div
          className="profile-mobile-item-icon"
          style={{ backgroundColor: '#fee2e2' }}
        >
          <span style={{ color: '#ef4444' }}>
            <LogOut size={22} />
          </span>
        </div>

        <span className="profile-mobile-item-title">
          Log Out
        </span>

        <ChevronRight className="profile-mobile-item-arrow" />
      </div>
      <div className="profile-menu-card profile-logout-card" onClick={handleDeleteProfile}>
        <div className="profile-menu-icon" style={{ backgroundColor: '#fee2e2' }}>
          <span style={{ color: '#ef4444' }}>
            <LogOut size={22} />
          </span>
        </div>

        <h5 className="profile-menu-title">Delete Account</h5>
        <p className="profile-menu-subtitle">Permanently remove your profile</p>

        <ChevronRight className="profile-menu-arrow" />
      </div>
    </div>
  );
};

export default ProfileMobileMenu;